import axios from '../../axiosInstances/axiosInstance';

export const getTransactionHistory = () => {
  return axios.get(`/users/transactionHistory`);
};
